function BrandUsersController($scope, UsersService, PermissionService, $stateParams, $state) {
    var self = this;

    self.initialise = function() {

    };

    self.initialise();
}

angular
    .module('dashboard')
    .component('brandUsers',
        {
            templateUrl: 'components/brand/users/users.9b224ad1.html',
            bindings: {},
            controller: ['$scope', 'UsersService', 'PermissionService', '$stateParams', '$state', BrandUsersController]
        });